var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "location_general" },
    [
      _c(
        "b-tabs",
        { attrs: { "content-class": "mt-3 mb-4" } },
        _vm._l(_vm.tabs, function (tab, index) {
          return _c(
            "b-tab",
            {
              key: index,
              attrs: { title: _vm.get_tab_title(tab), active: tab.is_active },
              on: {
                click: function ($event) {
                  return _vm.set_active(index)
                },
              },
            },
            [
              _c(
                "template",
                { slot: "title" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.get_tab_title(tab)) +
                      "\n                "
                  ),
                  tab.is_load
                    ? _c("b-spinner", { attrs: { type: "grow", small: "" } })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              tab.index == "general_base_params"
                ? _c("div", { staticClass: "form-group mt-2" }, [
                    _c(
                      "label",
                      {
                        staticClass: "form-label",
                        attrs: { for: "linked_rest" },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.__t("LINKED_REST")) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.restaurants.length > 0
                      ? _c(
                          "div",
                          {},
                          [
                            _c(
                              "v-select",
                              {
                                staticClass: "imc_reasons",
                                attrs: {
                                  id: "linked_rest",
                                  label: "title",
                                  reduce: function (rest) {
                                    return rest.id
                                  },
                                  filter: _vm.searchRest,
                                  options: _vm.restaurants,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "option",
                                      fn: function (option) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "d-center" },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(option.title) +
                                                    "\n                                "
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("div", [
                                                _c("small", [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(option.uniq_id) +
                                                      " " +
                                                      _vm._s(option.address) +
                                                      "\n                                    "
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: _vm.location.link_id,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.location, "link_id", $$v)
                                  },
                                  expression: "location.link_id",
                                },
                              },
                              [
                                _c("template", { slot: "no-options" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.__t("CHOOSE_POS_REST")) +
                                      "\n                        "
                                  ),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.marketings.length > 0
                      ? _c("div", { staticClass: "mt-4" }, [
                          _c(
                            "label",
                            {
                              staticClass: "form-label",
                              attrs: { for: "marketing" },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.__t("MARKETING")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {},
                            [
                              _c(
                                "v-select",
                                {
                                  staticClass: "imc_reasons",
                                  attrs: {
                                    id: "marketing",
                                    label: "name",
                                    reduce: function (item) {
                                      return item.id
                                    },
                                    options: _vm.marketings,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "option",
                                        fn: function (option) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "d-center" },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(option.name) +
                                                      "\n                                    "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _c("small", [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(option.id) +
                                                        "\n                                        "
                                                    ),
                                                  ]),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: _vm.location.marketing_uniq_id,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.location,
                                        "marketing_uniq_id",
                                        $$v
                                      )
                                    },
                                    expression: "location.marketing_uniq_id",
                                  },
                                },
                                [
                                  _c("template", { slot: "no-options" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.__t("CHOOSE_POS_REST")) +
                                        "\n                            "
                                    ),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              tab.index == "payments"
                ? _c(
                    "div",
                    { staticClass: "payment mt-2" },
                    [
                      _c("div", { staticClass: "panel-tag" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.__t("PAYMENT_PARAM")) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("location_payment", {
                        attrs: { location: _vm.location },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              tab.index == "shipments"
                ? _c(
                    "div",
                    { staticClass: "shipment mt-2" },
                    [
                      _c("div", { staticClass: "panel-tag" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.__t("SHIPMENT_PARAM")) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("location_shipment", {
                        attrs: { location: _vm.location },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              tab.index == "auto_delivery"
                ? _c(
                    "div",
                    { staticClass: "auto_delivery" },
                    [
                      _c("delivery_block", {
                        attrs: { location: _vm.location },
                        on: {
                          on_change_delivery_settings:
                            _vm.set_delivery_settings,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }